import(/* webpackMode: "eager" */ "/vercel/path0/app/components/PopOver.jsx");
import(/* webpackMode: "eager" */ "/vercel/path0/app/components/Review.jsx");
import(/* webpackMode: "eager" */ "/vercel/path0/app/components/ReviewTop.jsx");
import(/* webpackMode: "eager" */ "/vercel/path0/app/components/vaughanmap.jsx");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js")